export default __webpack_public_path__ + "static/media/Down2.9fc44535.svg";